export const getStyles = () => {
    const styles = {
        loginBtn: {
            mt: 2,
            backgroundColor: "#18933A",
            color: '#FFFFFF'
        }
    };
    return styles;
}